import { GQLOrganizationRegion } from '@upheal/graphql/definitions/schema.generated';
import { useAppState } from '@upheal/shared/state';

const REGION_LOCALE_PREFIX: Record<GQLOrganizationRegion, string> = {
    [GQLOrganizationRegion.US]: '',
    [GQLOrganizationRegion.CA]: '/en-ca',
    [GQLOrganizationRegion.UK]: '/uk',
    [GQLOrganizationRegion.AU]: '/au',
    [GQLOrganizationRegion.NZ]: '/nz',
    [GQLOrganizationRegion.EU]: '/en-ie',
    [GQLOrganizationRegion.Other]: '',
};

export const usePricingUrl = () => {
    const { organizations } = useAppState();

    const region = organizations[0]?.region ?? GQLOrganizationRegion.US;
    const prefix = REGION_LOCALE_PREFIX[region];
    const baseUrl = `https://www.upheal.io${prefix}/pricing`;

    return {
        pricingUrl: baseUrl,
        plansComparisonUrl: `${baseUrl}#comparison`,
    };
};
